import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CustomSourceSelectorComponent } from './custom-source-selector.component';
import { GenericSelectorComponent } from './generic-selector.component';
import { EnergySourceSelectorComponent } from './energy-source-selector.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  declarations: [
    GenericSelectorComponent,
    CustomSourceSelectorComponent,
    EnergySourceSelectorComponent,
  ],
  exports: [
    CustomSourceSelectorComponent,
    EnergySourceSelectorComponent,
  ],
})
export class CustomSourceSelectorModule { }
